const SpanishIcon = (props) => (
  <svg
    version="1.1"
    id="Layer_1"
    x="0rem"
    y="0rem"
    viewBox="0 0 512 512"
    with={props.with}
    height={props.height}
  >
    <path
      fill="#FFDA44"
      d="M0,256c0,31.314,5.633,61.31,15.923,89.043L256,367.304l240.077-22.261
	C506.367,317.31,512,287.314,512,256s-5.633-61.31-15.923-89.043L256,144.696L15.923,166.957C5.633,194.69,0,224.686,0,256z"
    />
    <rect y="85.331" fill="#FFDA44" width="512" height="341.337" />
    <rect y="85.331" fill="#D80027" width="512" height="113.775" />
    <rect y="312.882" fill="#D80027" width="512" height="113.775" />
  </svg>
);

export default SpanishIcon;
